import { render, staticRenderFns } from "./FilterDeliveryAlertHistory.vue?vue&type=template&id=15f5eeb6"
import script from "./FilterDeliveryAlertHistory.vue?vue&type=script&lang=ts"
export * from "./FilterDeliveryAlertHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports